import { render, staticRenderFns } from "./CetakPindahLokasi.vue?vue&type=template&id=035a70c4&"
import script from "./CetakPindahLokasi.vue?vue&type=script&lang=ts&"
export * from "./CetakPindahLokasi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('035a70c4')) {
      api.createRecord('035a70c4', component.options)
    } else {
      api.reload('035a70c4', component.options)
    }
    module.hot.accept("./CetakPindahLokasi.vue?vue&type=template&id=035a70c4&", function () {
      api.rerender('035a70c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/berita-acara/ba-pindah-lokasi/CetakPindahLokasi.vue"
export default component.exports